import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from '../../../../types/ReportResult';

export async function apiGenerateWorkOrderReport(workOrderID: number): Promise<ReportResult> {
    try {
        return await apiClient.get("report/work-order",
            {
                params:
                {
                    workOrderID: workOrderID
                }
            });
    } catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            data: ''
        };
    }
};
